import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { db } from '../firebase';

// No entry under user_roles/{uid} at all = admin (unrestricted). An explicit
// entry with role:'manager' scopes them to their `kiosks` list. An explicit
// entry with any other role (e.g. 'revoked', written when pulling a
// manager's access — see ManageManagers.js) grants zero kiosks, NOT admin.
export function useUserRole(user) {
  const [role, setRole] = useState(null);
  const [kiosks, setKiosks] = useState(null); // null = unrestricted, [] or [...] = scoped
  const [name, setName] = useState(null);     // manager's display name, if set
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRole(null);
      setKiosks(null);
      setName(null);
      setRoleLoading(false);
      return;
    }

    setRoleLoading(true);
    get(ref(db, `user_roles/${user.uid}`))
      .then((snap) => {
        const data = snap.val();
        if (!data) {
          setRole('admin');
          setKiosks(null);
          setName(null);
        } else if (data.role === 'manager') {
          setRole('manager');
          setKiosks(Array.isArray(data.kiosks) ? data.kiosks : []);
          setName(data.name || null);
        } else {
          setRole(data.role || 'revoked');
          setKiosks([]);
          setName(data.name || null);
        }
      })
      .catch(() => {
        // Read failed (network blip, etc.) — default to admin rather than
        // locking the owner out of their own dashboard. Acceptable given
        // this feature is already UI-only, trust-based access control, not
        // a hard security boundary (see plan notes).
        setRole('admin');
        setKiosks(null);
        setName(null);
      })
      .finally(() => setRoleLoading(false));
  }, [user]);

  return { role, kiosks, name, roleLoading };
}
